import users from 'modules/core/store/collections/users'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import employees from 'modules/employees/store/collections/employees'
import { employeeManagedEmployees } from 'modules/employees/store/collections/employeesContractVersions'
import type Employee from 'modules/employees/store/models/Employee'
import memberships from 'modules/teams/store/collections/memberships'
import teams from 'modules/teams/store/collections/teams'
import { peopleLedByEmployee } from 'modules/teams/store/peopleLedByEmployee'

export function selectableEmployeesByCurrent(contractVersions: ContractVersions): Employee[] {
  if (users.current.policy.can('timePlanning.planningVersionCreateEverybody')) {
    return employees.active
  }

  const employee = users.current.employee
  if (!employee) return []

  let list = users.current.policy.can('timePlanning.planningVersionCreateOwned') ? [employee] : []

  if (users.current.policy.can('timePlanning.planningVersionCreateReportees')) {
    list = list.concat(employeeManagedEmployees(employee, contractVersions))
  }

  if (users.current.policy.can('timePlanning.planningVersionCreateTeam')) {
    list = list.concat(peopleLedByEmployee(teams, memberships, employee.id, contractVersions))
  }

  return list
}
